import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'assets/css/index.scss'
import VueLazyload from 'vue-lazyload'
import Dialog from 'components/Dialog/index.js'
// import Img from '@/components/Img/index.js'
import http from '@/api/all.js'

// import http from '@/utils/index.js'
/* 信息提示封装组件 */
import toastPlugin from 'components/Toast/index.js'
// import lottie from 'vue-lottie';
// Vue.component('lottie', lottie)
import Vant from 'vant';
import 'vant/lib/index.css';
import 'vant/lib/tabs/style';
Vue.use(Vant);


Vue.config.productionTip = false

Vue.use(Element)
Vue.use(toastPlugin)
Vue.use(Dialog)
// Vue.use(Img)

// Vue.use(Layout)
Vue.use(VueLazyload, {
  preLoad: 1.3,
})
if (localStorage.getItem('user')) {
  // 初始化websocket连接
  // Websocket.init()
  store.commit('setUser', JSON.parse(localStorage.getItem('user')))
}
/* 注册全局tips */
Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
}
/* 注册全局的http */
Vue.prototype.$http = http;

// 初始化与QT的连接
/* 注册全局指令 */
Vue.directive('loadmore', {
  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper')
    selectWrap.addEventListener('scroll', function () {
      let sign = 0
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
      if (scrollDistance <= sign) {
        binding.value()
      }
    })
  }
})
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
